'use strict';
(function($){
	/*
	 * Vetology.JsonTables widget
	 *
	 * @description This ios the main Vetology widget to load the tools needed in the page
	 *				By the time this plugin runs, all othrs should have already been loaded, so this should be the last script to be loaded;
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.JsonTables',
		{
			"options": {},
			/*
			 * Vetology.Vetology._init
			 *
			 * @description	Initializes the Vetology Platform
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o.element.FormHelper();
				o.helper = o.element.data("Vetology-FormHelper");
				o.options.values = o.element.data("value");
				o.options.settings = o.element.data("config");
				o._loadTable();
				o._loadTableValues();
				o._loadEvents();
			},
			"_loadTable": function(){
				var o = this;
				var html = '<div class="table table-responsive">';
				html += '<table class="table table-stripped">';
				html += '<thead>';
				html += '<tr>';
				html += '<th></th>';
				$.each(o.options.settings, function(i, col){
					html += '<th>';
					html += col.title;
					html += '</th>';
				});
				html += '<th><a href="#" class="vetology_pd add_row"><span class="vetology-plus"></span></a></th>';
				html += '</tr>';
				html += '</thead>';
				html += '<tbody>';
				html += '</tbody>';
				html += '</table>';
				html += '</div>';
				o.element.find(".json_manager").append(html);
			},
			"_loadTableValues": function(){
				var o = this;
				var html = '';
				$.each(o.options.values, function(i, v){
					html += o._getRow(v);
				});
				o.element.find("tbody").append(html).sortable({handle: ".vetology-move"});
			},
			"_loadEvents": function(){
				var o = this;
				var html = '';
				o.element.on("click", ".add_row", function(){
					var html = o._getRow({});
					var $html = $(html);
					$("select[data-index!='2']", $html).attr("data-index", "1");
					o.element.find("tbody").append($html);
				});
				o.element.on("click", ".remove_row", function(){
					$(this).removeClass("remove_row").addClass("restore_row").find("span").attr("class", "vetology-rotate-ccw").closest("tr").addClass("danger");
				});
				o.element.on("click", ".restore_row", function(){
					$(this).removeClass("restore_row").addClass("remove_row").find("span").attr("class", "vetology-delete").closest("tr").removeClass("danger");
				});
			},
			"_getRow": function(settings){
				var o = this;
				var parent_class = "";
				var html = '<td><span class="vetology-move"></span></td>';
				$.each(o.options.settings, function(a, s){
					parent_class = typeof s.row_class != "undefined" ? s.row_class : parent_class;
					html += '<td class="' + (typeof s.td_class != "undefined" ? s.td_class : "") + '">';
					var class_name = typeof s.class != "undefined" ? s.class : "";
					switch(s.type){
						case 'autocomplete':
							html += o.helper.getAutocompleteInput(false, (typeof settings[s.id] != "undefined" ? settings[s.id] : ""), "input_" + s.id + " " + class_name, s);
						break;
						case 'text':
							html += o.helper.getBaseInput(false, (typeof settings[s.id] != "undefined" ? settings[s.id] : ""), "input_" + s.id + " " + class_name);
						break;
						case 'editor':
							html += o.helper.getBaseTextEditor(false, (typeof settings[s.id] != "undefined" ? settings[s.id] : ""), "input_" + s.id + " " + class_name);
						break;
						case 'select':
							html += o.helper.getBaseSelect(false, (typeof settings[s.id] != "undefined" ? settings[s.id] : ""), "input_" + s.id + " " + class_name, s.options);
						break;
						default:
							html += o.helper.getBaseInput(false, (typeof settings[s.id] != "undefined" ? settings[s.id] : ""), "input_" + s.id + " " + class_name);
						break;
					}
					html += '</td>';
				});
				html += '<td><a href="#" class="vetology_pd remove_row"><span class="vetology-delete"></span></a></td>';
				html = '<tr class="' + parent_class + '">' + html + '</tr>';
				return html;
			},
			"updateRows": function(){
				var o = this;
				var newVal = [];
				var rows = o.element.find("tbody tr");
				$.each(rows, function(i, row){
					row = $(row);
					if(row.hasClass("danger")){
						return true;
					}
					var n = {};
					$.each(o.options.settings, function(a, s){
                        n[s.id] = row.find('.input_' + s.id).val();
					});
					newVal.push(n);
				});
				newVal = JSON.stringify(newVal);
				o.element.find(".current_value").val(newVal)
                    .trigger('jsonTableUpdated', JSON.stringify(o.options.settings));
			}
		}
	);
})(jQuery);
